import React, { Component } from "react";
import { injectStripe } from "react-stripe-elements";
import bankAccountTip from "images/bank-account-tip.svg";
import "./bank-payment-method.css";
import {
  FormGroup,
  FormControl,
  Button,
  ControlLabel,
  Checkbox
} from "react-bootstrap";

class BankPaymentMethod extends Component {
  render() {
    let legalText =
      "I authorize Finpay to electronically debit my account and, if necessary, " +
      "electronically credit my account to correct erroneous debits.";

    return (
      <div>
        <form
          onSubmit={event => this.props.handleSubmitNewBankAccount(event, this)}
          className="clearfix bank-account-form"
        >
          <div className="col-md-6">
            <FormGroup>
              <ControlLabel>Name on account</ControlLabel>
              <FormControl
                id="account-holder-name"
                bsSize="sm"
                type="text"
                name="account-holder-name"
                required="true"
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Bank Name</ControlLabel>
              <FormControl
                id="bank-name"
                bsSize="sm"
                type="text"
                name="bank-name"
                required="true"
              />
            </FormGroup>
            <FormGroup>
              <input
                type="hidden"
                id="account-holder-type"
                name="account-holder-type"
                value="individual"
                required="true"
              />
              <input type="hidden" id="currency" name="currency" value="usd" />
              <input type="hidden" id="country" name="country" value="US" />
            </FormGroup>
          </div>

          <div className="col-md-6">
            <FormGroup>
              <ControlLabel>Routing Number</ControlLabel>
              <FormControl
                id="routing-number"
                bsSize="sm"
                type="text"
                name="routing-number"
                minLength="9"
                maxLength="9"
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Account Number</ControlLabel>
              <FormControl
                id="account-number"
                bsSize="sm"
                type="text"
                name="account-number"
                required="true"
              />
            </FormGroup>
          </div>

          <div>
            <div className="col-md-12 text-center">
              <img
                src={bankAccountTip}
                className="bank-account-tip"
                alt="payment method"
              />
            </div>
            <div className="col-md-12">
              <FormGroup>
                <Checkbox required="true">
                  <p className="legal-text">{legalText}</p>
                </Checkbox>
              </FormGroup>
            </div>
          </div>

          <div className="col-md-12">
            <Button type="submit" className="btn btn-warning pull-right">
              Save
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default injectStripe(BankPaymentMethod);



// WEBPACK FOOTER //
// ./src/home/components/bank-payment-method.js